/**
 * @generated SignedSource<<53342d6391c4dfd14cbe74010799b26e>>
 * @relayHash 2d3d6d832426b1ae43702a1d8ca62269
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-nft/576.0.0-2026-09-10T13:50:28.537Z/nftPdpRespRootQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type nftPdpRespRootQuery$variables = {
  creatorItemCount?: number | null;
  fetchClientDetails?: boolean | null;
  fetchSplitName?: boolean | null;
  fetchUser?: boolean | null;
  isDraft?: boolean | null;
  nftId: string;
  userId?: string | null;
};
export type nftPdpRespRootQuery$data = {
  readonly viewer: {
    readonly nftItems: ReadonlyArray<{
      readonly creatorAddress: {
        readonly publicProfile: {
          readonly profileName: string | null;
        } | null;
      } | null;
      readonly metadata: {
        readonly description?: string | null;
        readonly media?: {
          readonly mimeType: string | null;
          readonly posterFrameUrl: string | null;
          readonly webUrl: string | null;
        } | null;
        readonly name?: string | null;
      } | null;
      readonly pdpUrl: string | null;
      readonly removed: boolean | null;
      readonly wasBurned: boolean | null;
    } | null> | null;
    readonly " $fragmentSpreads": FragmentRefs<"NftHeaderLayout_viewer" | "NftPdpRespLayout_viewer">;
  };
};
export type nftPdpRespRootQuery = {
  response: nftPdpRespRootQuery$data;
  variables: nftPdpRespRootQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": 4,
  "kind": "LocalArgument",
  "name": "creatorItemCount"
},
v1 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchClientDetails"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchSplitName"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchUser"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isDraft"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "nftId"
},
v6 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userId"
},
v7 = {
  "items": [
    {
      "kind": "Variable",
      "name": "nftIds.0",
      "variableName": "nftId"
    }
  ],
  "kind": "ListValue",
  "name": "nftIds"
},
v8 = [
  {
    "kind": "Variable",
    "name": "isDraft",
    "variableName": "isDraft"
  },
  (v7/*:: as any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pdpUrl",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "wasBurned",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "removed",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profileName",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "webUrl",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mimeType",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "posterFrameUrl",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "Photo",
  "kind": "LinkedField",
  "name": "avatarImage",
  "plural": false,
  "selections": [
    (v20/*:: as any*/),
    (v18/*:: as any*/)
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ensDomain",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publicProfileUrl",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDibsAddress",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "balance",
  "storageKey": null
},
v27 = [
  {
    "kind": "Literal",
    "name": "feature",
    "value": "allowWalletConnect"
  }
],
v28 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 6
  }
],
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCursor",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ether",
  "storageKey": null
},
v33 = [
  (v32/*:: as any*/)
],
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "PublicProfile",
  "kind": "LinkedField",
  "name": "publicProfile",
  "plural": false,
  "selections": [
    (v12/*:: as any*/),
    (v18/*:: as any*/)
  ],
  "storageKey": null
},
v35 = [
  (v19/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isAddressZero",
    "storageKey": null
  },
  (v24/*:: as any*/),
  (v34/*:: as any*/),
  (v25/*:: as any*/),
  (v23/*:: as any*/),
  (v18/*:: as any*/)
],
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "from",
  "plural": false,
  "selections": (v35/*:: as any*/),
  "storageKey": null
},
v37 = [
  (v19/*:: as any*/),
  (v24/*:: as any*/),
  (v34/*:: as any*/),
  (v25/*:: as any*/),
  (v23/*:: as any*/),
  (v18/*:: as any*/)
],
v38 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currency",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rate",
    "storageKey": null
  }
],
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "NftConversionRateEvent",
  "kind": "LinkedField",
  "name": "endedConversionRates",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EtherRates",
      "kind": "LinkedField",
      "name": "rates",
      "plural": true,
      "selections": (v38/*:: as any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "NftAuction",
  "kind": "LinkedField",
  "name": "auction",
  "plural": false,
  "selections": [
    (v39/*:: as any*/),
    (v18/*:: as any*/)
  ],
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "EtherAmount",
  "kind": "LinkedField",
  "name": "reservePrice",
  "plural": false,
  "selections": (v33/*:: as any*/),
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tokenId",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "to",
  "plural": false,
  "selections": (v35/*:: as any*/),
  "storageKey": null
},
v44 = [
  (v19/*:: as any*/),
  (v18/*:: as any*/)
],
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "operator",
  "plural": false,
  "selections": (v44/*:: as any*/),
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "auctionId",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "contractAddress",
  "plural": false,
  "selections": (v44/*:: as any*/),
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ctaCopy",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ctaHref",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v56 = [
  (v53/*:: as any*/),
  (v54/*:: as any*/),
  (v55/*:: as any*/)
],
v57 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "excludeItemIds.0",
        "variableName": "nftId"
      }
    ],
    "kind": "ListValue",
    "name": "excludeItemIds"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "creatorItemCount"
  }
],
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "edition",
  "storageKey": null
},
v59 = [
  (v19/*:: as any*/),
  (v34/*:: as any*/),
  (v23/*:: as any*/),
  (v18/*:: as any*/)
],
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "concreteType": "EtherRates",
  "kind": "LinkedField",
  "name": "etherRates",
  "plural": true,
  "selections": (v38/*:: as any*/),
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "sellerAddress",
  "plural": false,
  "selections": (v44/*:: as any*/),
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "concreteType": "NftItemLikes",
  "kind": "LinkedField",
  "name": "likes",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "likeCount",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalSupply",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isERC1155",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tokenUri",
  "storageKey": null
},
v67 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v68 = [
  (v67/*:: as any*/)
],
v69 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "ownerAddress",
  "plural": false,
  "selections": (v44/*:: as any*/),
  "storageKey": null
},
v70 = {
  "condition": "fetchUser",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": (v68/*:: as any*/),
      "concreteType": "NftItemBalance",
      "kind": "LinkedField",
      "name": "balanceForUser",
      "plural": false,
      "selections": [
        (v26/*:: as any*/),
        (v18/*:: as any*/),
        (v69/*:: as any*/)
      ],
      "storageKey": null
    }
  ]
},
v71 = [
  {
    "kind": "Literal",
    "name": "excludeCanceled",
    "value": true
  }
],
v72 = [
  (v49/*:: as any*/),
  (v48/*:: as any*/),
  (v50/*:: as any*/),
  (v18/*:: as any*/)
],
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "caption",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "wei",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "concreteType": "PublicProfile",
  "kind": "LinkedField",
  "name": "publicProfile",
  "plural": false,
  "selections": [
    (v22/*:: as any*/),
    (v21/*:: as any*/),
    (v18/*:: as any*/)
  ],
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allocation",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "basisPoints",
  "storageKey": null
},
v78 = [
  (v19/*:: as any*/),
  (v23/*:: as any*/),
  (v75/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "NftSplit",
    "kind": "LinkedField",
    "name": "split",
    "plural": false,
    "selections": [
      {
        "condition": "fetchSplitName",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v68/*:: as any*/),
            "concreteType": "NftSplitBookmark",
            "kind": "LinkedField",
            "name": "bookmark",
            "plural": false,
            "selections": [
              (v13/*:: as any*/),
              (v18/*:: as any*/)
            ],
            "storageKey": null
          }
        ]
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "distributorFee",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EthereumAddressType",
        "kind": "LinkedField",
        "name": "controllerAddress",
        "plural": false,
        "selections": [
          (v19/*:: as any*/),
          (v23/*:: as any*/),
          (v18/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NftSplitAllocation",
        "kind": "LinkedField",
        "name": "allocations",
        "plural": true,
        "selections": [
          (v76/*:: as any*/),
          (v77/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EthereumAddressType",
            "kind": "LinkedField",
            "name": "address",
            "plural": false,
            "selections": [
              (v19/*:: as any*/),
              (v23/*:: as any*/),
              (v75/*:: as any*/),
              (v18/*:: as any*/)
            ],
            "storageKey": null
          },
          (v18/*:: as any*/)
        ],
        "storageKey": null
      },
      (v18/*:: as any*/)
    ],
    "storageKey": null
  },
  (v18/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/),
      (v6/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "nftPdpRespRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "NftPdpRespLayout_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "NftHeaderLayout_viewer"
          },
          {
            "alias": null,
            "args": (v8/*:: as any*/),
            "concreteType": "NftItem",
            "kind": "LinkedField",
            "name": "nftItems",
            "plural": true,
            "selections": [
              (v9/*:: as any*/),
              (v10/*:: as any*/),
              (v11/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "EthereumAddressType",
                "kind": "LinkedField",
                "name": "creatorAddress",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PublicProfile",
                    "kind": "LinkedField",
                    "name": "publicProfile",
                    "plural": false,
                    "selections": [
                      (v12/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v13/*:: as any*/),
                      (v14/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NftDigitalArtMetadataMedia",
                        "kind": "LinkedField",
                        "name": "media",
                        "plural": false,
                        "selections": [
                          (v15/*:: as any*/),
                          (v16/*:: as any*/),
                          (v17/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "NftDigitalArtMetadata",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*:: as any*/),
      (v6/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v1/*:: as any*/),
      (v4/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "nftPdpRespRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v18/*:: as any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "nftId",
                "variableName": "nftId"
              }
            ],
            "concreteType": "NftItemBalance",
            "kind": "LinkedField",
            "name": "nftBalancesByItem",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EthereumAddressType",
                "kind": "LinkedField",
                "name": "ownerAddress",
                "plural": false,
                "selections": [
                  (v19/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PublicProfile",
                    "kind": "LinkedField",
                    "name": "publicProfile",
                    "plural": false,
                    "selections": [
                      (v21/*:: as any*/),
                      (v18/*:: as any*/),
                      (v12/*:: as any*/),
                      (v22/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v23/*:: as any*/),
                  (v24/*:: as any*/),
                  (v18/*:: as any*/),
                  (v25/*:: as any*/)
                ],
                "storageKey": null
              },
              (v18/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "chainId",
                "storageKey": null
              },
              (v26/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "walletConnectFeatureFlag",
            "args": (v27/*:: as any*/),
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"allowWalletConnect\")"
          },
          {
            "alias": "nftBenignNeglect",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "nftBenignNeglect"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"nftBenignNeglect\")"
          },
          {
            "alias": "walletConnectEnabled",
            "args": (v27/*:: as any*/),
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"allowWalletConnect\")"
          },
          {
            "alias": "isNftAuctionV2Enabled",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "nftAuctionV2"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"nftAuctionV2\")"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "itemId",
                "variableName": "nftId"
              }
            ],
            "concreteType": "NftItemHistory",
            "kind": "LinkedField",
            "name": "nftItemHistory",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v28/*:: as any*/),
                "concreteType": "NftItemHistoryEventsConnection",
                "kind": "LinkedField",
                "name": "events",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      (v29/*:: as any*/),
                      (v30/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NftItemHistoryEventsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v31/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "timestamp",
                            "storageKey": null
                          },
                          (v18/*:: as any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isNftItemHistoryEvent"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "transactionHash",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EtherAmount",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": false,
                            "selections": (v33/*:: as any*/),
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v36/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EthereumAddressType",
                                "kind": "LinkedField",
                                "name": "to",
                                "plural": false,
                                "selections": (v37/*:: as any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "NftItemHistoryTransferEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v40/*:: as any*/),
                              (v41/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EthereumAddressType",
                                "kind": "LinkedField",
                                "name": "auctionCreator",
                                "plural": false,
                                "selections": (v37/*:: as any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "NftItemHistoryAuctionCreatedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v40/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EtherAmount",
                                "kind": "LinkedField",
                                "name": "bidAmount",
                                "plural": false,
                                "selections": (v33/*:: as any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EthereumAddressType",
                                "kind": "LinkedField",
                                "name": "bidder",
                                "plural": false,
                                "selections": (v37/*:: as any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "NftItemHistoryAuctionBidEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isPaused",
                                "storageKey": null
                              }
                            ],
                            "type": "NftItemHistoryAuctionPausedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v40/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EtherAmount",
                                "kind": "LinkedField",
                                "name": "winningBid",
                                "plural": false,
                                "selections": (v33/*:: as any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EthereumAddressType",
                                "kind": "LinkedField",
                                "name": "winningBidder",
                                "plural": false,
                                "selections": (v37/*:: as any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "NftItemHistoryAuctionEndedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EthereumAddressType",
                                "kind": "LinkedField",
                                "name": "canceledBy",
                                "plural": false,
                                "selections": (v37/*:: as any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "NftItemHistoryAuctionCanceledEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v42/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "valueArg",
                                "storageKey": null
                              },
                              (v36/*:: as any*/),
                              (v43/*:: as any*/),
                              (v45/*:: as any*/)
                            ],
                            "type": "NftItemHistoryTransferSingleEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "values",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "ids",
                                "storageKey": null
                              },
                              (v36/*:: as any*/),
                              (v43/*:: as any*/),
                              (v45/*:: as any*/)
                            ],
                            "type": "NftItemHistoryTransferBatchEvent",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v46/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "events(first:6)"
              },
              {
                "alias": null,
                "args": (v28/*:: as any*/),
                "filters": null,
                "handle": "connection",
                "key": "NftPdpHistory_events",
                "kind": "LinkedHandle",
                "name": "events"
              },
              (v18/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v8/*:: as any*/),
            "concreteType": "NftItem",
            "kind": "LinkedField",
            "name": "nftItems",
            "plural": true,
            "selections": [
              (v47/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NftAuction",
                "kind": "LinkedField",
                "name": "mostRecentAuction",
                "plural": false,
                "selections": [
                  (v48/*:: as any*/),
                  (v18/*:: as any*/),
                  (v49/*:: as any*/),
                  (v50/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NftCmsExhibitionPage",
                "kind": "LinkedField",
                "name": "exhibitions",
                "plural": true,
                "selections": [
                  (v31/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "urlLabel",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NftCmsExhibitionHeroBannerType",
                    "kind": "LinkedField",
                    "name": "heroBanner",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "bannerConfig",
                        "plural": false,
                        "selections": [
                          (v31/*:: as any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "eyeBrow",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "imageSize",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "captionPosition",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "backgroundColor",
                                "storageKey": null
                              },
                              (v51/*:: as any*/),
                              (v52/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "captionAlignment",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "header",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "dek",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "curator",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "color",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "ctaStyle",
                                "storageKey": null
                              }
                            ],
                            "type": "NftCmsExhibitionHtmlBannerType",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "burnIn",
                                "storageKey": null
                              },
                              (v51/*:: as any*/),
                              (v52/*:: as any*/)
                            ],
                            "type": "NftCmsExhibitionStaticBannerType",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "format",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NftCmsExhibitionImageType",
                        "kind": "LinkedField",
                        "name": "desktopImage",
                        "plural": false,
                        "selections": (v56/*:: as any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NftCmsExhibitionImageType",
                        "kind": "LinkedField",
                        "name": "mobileImage",
                        "plural": false,
                        "selections": (v56/*:: as any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EthereumAddressType",
                "kind": "LinkedField",
                "name": "creatorAddress",
                "plural": false,
                "selections": [
                  (v19/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PublicProfile",
                    "kind": "LinkedField",
                    "name": "publicProfile",
                    "plural": false,
                    "selections": [
                      (v12/*:: as any*/),
                      (v18/*:: as any*/),
                      (v21/*:: as any*/),
                      (v48/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "bio",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "webLink",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "instagramLink",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "twitterLink",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "facebookLink",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "wikipediaLink",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "discordLink",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v57/*:: as any*/),
                    "concreteType": "EthereumAddressCreatedItemsConnection",
                    "kind": "LinkedField",
                    "name": "createdItems",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EthereumAddressCreatedItemsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NftItem",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v47/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "metadata",
                                "plural": false,
                                "selections": [
                                  (v31/*:: as any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v13/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "NftDigitalArtMetadataMedia",
                                        "kind": "LinkedField",
                                        "name": "media",
                                        "plural": false,
                                        "selections": [
                                          (v16/*:: as any*/),
                                          (v15/*:: as any*/),
                                          (v17/*:: as any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "videoThumb",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v58/*:: as any*/)
                                    ],
                                    "type": "NftDigitalArtMetadata",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "NftAuction",
                                "kind": "LinkedField",
                                "name": "mostRecentAuction",
                                "plural": false,
                                "selections": [
                                  (v47/*:: as any*/),
                                  (v48/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "EtherAmount",
                                    "kind": "LinkedField",
                                    "name": "currentBid",
                                    "plural": false,
                                    "selections": (v33/*:: as any*/),
                                    "storageKey": null
                                  },
                                  (v41/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "EthereumAddressType",
                                    "kind": "LinkedField",
                                    "name": "winnerAddress",
                                    "plural": false,
                                    "selections": (v59/*:: as any*/),
                                    "storageKey": null
                                  },
                                  (v60/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "NftItem",
                                    "kind": "LinkedField",
                                    "name": "item",
                                    "plural": false,
                                    "selections": [
                                      (v61/*:: as any*/),
                                      (v18/*:: as any*/),
                                      (v9/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v39/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "EthereumAddressType",
                                    "kind": "LinkedField",
                                    "name": "creatorAddress",
                                    "plural": false,
                                    "selections": (v44/*:: as any*/),
                                    "storageKey": null
                                  },
                                  (v62/*:: as any*/),
                                  (v18/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v10/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LinkData",
                                "kind": "LinkedField",
                                "name": "linkData",
                                "plural": false,
                                "selections": [
                                  (v20/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isLinkable",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "importErrorReason",
                                "storageKey": null
                              },
                              (v18/*:: as any*/),
                              (v63/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EthereumAddressType",
                                "kind": "LinkedField",
                                "name": "creatorAddress",
                                "plural": false,
                                "selections": [
                                  (v24/*:: as any*/),
                                  (v34/*:: as any*/),
                                  (v18/*:: as any*/),
                                  (v19/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v64/*:: as any*/),
                              (v65/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EthereumAddressType",
                                "kind": "LinkedField",
                                "name": "ownerAddress",
                                "plural": false,
                                "selections": (v59/*:: as any*/),
                                "storageKey": null
                              },
                              (v42/*:: as any*/),
                              (v66/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "NftTokenContract",
                                "kind": "LinkedField",
                                "name": "contract",
                                "plural": false,
                                "selections": [
                                  (v13/*:: as any*/),
                                  (v18/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "EthereumAddressType",
                                    "kind": "LinkedField",
                                    "name": "addressWithFields",
                                    "plural": false,
                                    "selections": (v44/*:: as any*/),
                                    "storageKey": null
                                  },
                                  (v19/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v70/*:: as any*/),
                              {
                                "alias": "recentAuction",
                                "args": (v71/*:: as any*/),
                                "concreteType": "NftAuction",
                                "kind": "LinkedField",
                                "name": "mostRecentAuction",
                                "plural": false,
                                "selections": (v72/*:: as any*/),
                                "storageKey": "mostRecentAuction(excludeCanceled:true)"
                              },
                              (v9/*:: as any*/),
                              {
                                "alias": "auction",
                                "args": (v71/*:: as any*/),
                                "concreteType": "NftAuction",
                                "kind": "LinkedField",
                                "name": "mostRecentAuction",
                                "plural": false,
                                "selections": (v72/*:: as any*/),
                                "storageKey": "mostRecentAuction(excludeCanceled:true)"
                              },
                              (v31/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v46/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          (v30/*:: as any*/),
                          (v29/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v57/*:: as any*/),
                    "filters": [
                      "excludeItemIds"
                    ],
                    "handle": "connection",
                    "key": "NftCmsCreator_createdItems",
                    "kind": "LinkedHandle",
                    "name": "createdItems"
                  },
                  (v18/*:: as any*/),
                  (v24/*:: as any*/)
                ],
                "storageKey": null
              },
              (v65/*:: as any*/),
              (v42/*:: as any*/),
              (v66/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NftTokenContract",
                "kind": "LinkedField",
                "name": "contract",
                "plural": false,
                "selections": [
                  (v19/*:: as any*/),
                  (v13/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NftTokenContractImport",
                    "kind": "LinkedField",
                    "name": "tokenContractImport",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "collectionName",
                        "storageKey": null
                      },
                      (v18/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v18/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                  (v31/*:: as any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v13/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "medium",
                        "storageKey": null
                      },
                      (v58/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NftDigitalArtMetadataMedia",
                        "kind": "LinkedField",
                        "name": "media",
                        "plural": false,
                        "selections": [
                          (v53/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "dimensions",
                            "storageKey": null
                          },
                          (v15/*:: as any*/),
                          (v16/*:: as any*/),
                          (v17/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdYear",
                        "storageKey": null
                      },
                      (v14/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "aspectRatio",
                        "storageKey": null
                      }
                    ],
                    "type": "NftDigitalArtMetadata",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v64/*:: as any*/),
              (v9/*:: as any*/),
              (v18/*:: as any*/),
              (v63/*:: as any*/),
              (v61/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NftItemCmsLoader",
                "kind": "LinkedField",
                "name": "additionalInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "copy",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "videoEmbed",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "videoEmbedCaption",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NftItemCmsImage",
                    "kind": "LinkedField",
                    "name": "imageList",
                    "plural": true,
                    "selections": (v56/*:: as any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "imageListCaption",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NftExhibitionNote",
                "kind": "LinkedField",
                "name": "exhibitionNotes",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "contentList",
                    "plural": true,
                    "selections": [
                      (v31/*:: as any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v73/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NftExhibitionNoteImageListImage",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": true,
                            "selections": [
                              (v53/*:: as any*/),
                              (v55/*:: as any*/),
                              (v54/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "NftExhibitionNoteImageListContent",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "content",
                            "storageKey": null
                          }
                        ],
                        "type": "NftExhibitionNoteRichTextContent",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "embedCode",
                            "storageKey": null
                          },
                          (v73/*:: as any*/)
                        ],
                        "type": "NftExhibitionNoteVideoEmbedContent",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v18/*:: as any*/)
                ],
                "storageKey": null
              },
              (v10/*:: as any*/),
              (v11/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "showExhibitionNotes",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "nftExhibitionNotes"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"nftExhibitionNotes\")"
          },
          {
            "alias": "nftMintBlogEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "nftMintBlog"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"nftMintBlog\")"
          },
          {
            "alias": "nftSearchEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "nftSearch"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"nftSearch\")"
          },
          {
            "condition": "fetchUser",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v7/*:: as any*/),
                  (v67/*:: as any*/)
                ],
                "concreteType": "NftItemUserLike",
                "kind": "LinkedField",
                "name": "isNftItemsLikedByUser",
                "plural": true,
                "selections": [
                  (v18/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nftId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isLiked",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v68/*:: as any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "socialNetworkName",
                        "value": "ETHEREUM"
                      }
                    ],
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "socialNetworkByName",
                    "plural": false,
                    "selections": [
                      (v31/*:: as any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EthereumSocialConnectionUserPreferencesType",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "zipCode",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "EthereumSocialConnection",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v18/*:: as any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ],
                    "storageKey": "socialNetworkByName(socialNetworkName:\"ETHEREUM\")"
                  },
                  (v18/*:: as any*/),
                  (v47/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EthereumAddressType",
                    "kind": "LinkedField",
                    "name": "ethereumWalletAddress",
                    "plural": false,
                    "selections": (v44/*:: as any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "fetchClientDetails",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v8/*:: as any*/),
                "concreteType": "NftItem",
                "kind": "LinkedField",
                "name": "nftItems",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NftAuction",
                    "kind": "LinkedField",
                    "name": "mostRecentAuction",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EtherAmount",
                        "kind": "LinkedField",
                        "name": "currentBid",
                        "plural": false,
                        "selections": [
                          (v74/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v62/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EthereumAddressType",
                        "kind": "LinkedField",
                        "name": "winnerAddress",
                        "plural": false,
                        "selections": (v44/*:: as any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EthereumAddressType",
                        "kind": "LinkedField",
                        "name": "fundsRecipient",
                        "plural": false,
                        "selections": (v78/*:: as any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EtherAmount",
                        "kind": "LinkedField",
                        "name": "reservePrice",
                        "plural": false,
                        "selections": [
                          (v32/*:: as any*/),
                          (v74/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v60/*:: as any*/),
                      (v39/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NftTokenContract",
                    "kind": "LinkedField",
                    "name": "contract",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EthereumAddressType",
                        "kind": "LinkedField",
                        "name": "addressWithFields",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EthereumAddressType",
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": (v44/*:: as any*/),
                            "storageKey": null
                          },
                          (v18/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PaymentAddresses",
                    "kind": "LinkedField",
                    "name": "paymentAddresses",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PaymentAddress",
                        "kind": "LinkedField",
                        "name": "addresses",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EthereumAddressType",
                            "kind": "LinkedField",
                            "name": "address",
                            "plural": false,
                            "selections": (v78/*:: as any*/),
                            "storageKey": null
                          },
                          (v76/*:: as any*/),
                          (v77/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v69/*:: as any*/),
                  {
                    "alias": "lastLiveAuction",
                    "args": (v71/*:: as any*/),
                    "concreteType": "NftAuction",
                    "kind": "LinkedField",
                    "name": "mostRecentAuction",
                    "plural": false,
                    "selections": [
                      (v62/*:: as any*/),
                      (v18/*:: as any*/)
                    ],
                    "storageKey": "mostRecentAuction(excludeCanceled:true)"
                  },
                  (v58/*:: as any*/),
                  (v70/*:: as any*/)
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-nft/576.0.0-2026-09-10T13:50:28.537Z/nftPdpRespRootQuery",
    "metadata": {},
    "name": "nftPdpRespRootQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9d3d14e9e037659298d6e7fe12858471";

export default node;
